import MessagingBase from './messaging-base';

export default class MessagingMessage extends MessagingBase {
  // Renaming "content" here as it collides with reserved attribute name.
  attrs = {
    text: { key: 'content' },
  };
}
